export default defineNuxtPlugin(() => {
  const publicConfig = useRuntimeConfig().public
  const refName = String(publicConfig.buildRefName || '').trim()
  const commitSha = String(publicConfig.buildCommitSha || '').trim()
  const pipelineId = String(publicConfig.buildPipelineId || '').trim()
  const buildTime = String(publicConfig.buildTime || '').trim()
  const commitLabel = commitSha.slice(0, 8)
  const buildIdentity = refName && commitLabel ? `${refName}(${commitLabel})` : refName || commitLabel
  const parsedBuildTime = Date.parse(buildTime)
  const buildDate = buildTime && Number.isFinite(parsedBuildTime)
    ? new Date(parsedBuildTime).toISOString().slice(2, 10).replaceAll('-', '')
    : buildTime
  const buildLine = [buildIdentity, pipelineId ? `#${pipelineId}` : '', buildDate].filter(Boolean).join(' ')
  const currentYear = new Date().getFullYear()

  console.log(
    [
      '%cYuelai Engine Blog Plugin%c',
      `Copyright © 2017-${currentYear} YuelaiGroup (悦来)`,
      'https://www.yuelaigroup.com',
      ...(buildLine ? [`CI/CD ${buildLine}`] : [])
    ].join('\n'),
    'color:#fff;background:#1f6feb;padding:4px 10px;font-size:13px;',
    'color:inherit;'
  )
})
